exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header[data-v-69914286]{padding:0;margin:0;margin-bottom:35px;border-bottom:0}.head-title[data-v-69914286]{margin-bottom:20px;font-size:1.1rem}.modal-footer[data-v-69914286]{padding:0;margin-top:18px;border:0}.modal-body[data-v-69914286]{line-height:180%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69914286","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/admin/js/attendance/modals/BatchLockConfirmDialog.vue
// module id = Rc0C
// module chunks = 0